export default __webpack_public_path__ + "static/media/tutorialpoint.6e9beca0.png";